var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"olympic-matches-card"},_vm._l((_vm.pairs),function(pairResult,index){return _c('PairResultsData',{key:'pairResultIndex' + index,staticClass:"content",attrs:{"pairResult":pairResult}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }